export const TIME_START = 'project/pomodoro/timeStart'
export const TIME_STOP = 'project/pomodoro/timeStop'
export const TIME_ELAPSE = 'project/pomodoro/timeElapse'
export const TIME_RESET = 'project/pomodoro/timeReset'
export const CHANGE_STAGE = 'project/pomodoro/changeStage'
export const UPDATE_CONFIG = 'project/pomodoro/updateConfig'